export interface FloatingPosition {
  left: number;
  top: number;
}

/** Keep a fixed-position floating surface inside the usable viewport. The
 * surface itself may shrink below its preferred size through CSS max-width /
 * max-height; clamping the preferred box still guarantees a stable margin on
 * normal viewports and a non-negative origin on very small ones. */
export function clampFloatingPosition(
  anchorX: number,
  anchorY: number,
  viewportWidth: number,
  viewportHeight: number,
  preferredWidth: number,
  preferredHeight: number,
  margin = 12,
): FloatingPosition {
  const x = Number.isFinite(anchorX) ? anchorX : margin;
  const y = Number.isFinite(anchorY) ? anchorY : margin;
  const maxLeft = Math.max(margin, viewportWidth - preferredWidth - margin);
  const maxTop = Math.max(margin, viewportHeight - preferredHeight - margin);
  return {
    left: Math.max(margin, Math.min(x, maxLeft)),
    top: Math.max(margin, Math.min(y, maxTop)),
  };
}
